export default "__VITE_ASSET__72fab6e7__"